import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SitesComponent } from './sites/sites.component';
import { ShiftsComponent } from './shifts/shifts.component';
import { LoginComponent } from './login/login.component';
import { CountriesComponent } from './countries/countries.component';
import { BranchesComponent } from './branches/branches.component';
import { MyDayComponent } from './my-day/my-day.component';
import { MyBranchComponent } from './my-branch/my-branch.component';

const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'my-day', component: MyDayComponent },
  { path: 'login', component: LoginComponent },
  { path: 'sites', component: SitesComponent },
  { path: 'sites/:branch', component: SitesComponent},
  { path: 'shifts', component: ShiftsComponent },
  { path: 'shifts/:site', component: ShiftsComponent },
  { path: 'countries', component: CountriesComponent },
  { path: 'branches', component: BranchesComponent },
  { path: 'branches/:country', component: BranchesComponent },
  { path: 'my-branch', component: MyBranchComponent },
  // Wildcard route, redirect to login
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
